import React from 'react';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../../config/constants';
import type { MetaParagraphsContentTypes } from '../../../types/uncinc_profile/paragraphs';
import {
  facetAttributes,
  resultAttributes,
  searchAttributes,
  sorting,
} from './config';

// Subcomponents.
import EmptyState from './EmptyState';
import Facets from './Facets';
import Inner from './Inner';

interface Subcomponents {
  EmptyState: typeof EmptyState;
  Facets: typeof Facets;
  Inner: typeof Inner;
}

export interface MetaSearchProps extends Omit<SearchkitWrapperProps,
| 'connection'
| 'indexName'
| 'routing'
| 'searchSettings'
> {
  contentType: MetaParagraphsContentTypes;
  sortingList?: number[];
  withSearchbar?: boolean;
  withFacets?: boolean;
  withPagination?: boolean;
  disableScrollTo?: boolean;
}

const MetaSearch: React.FC<MetaSearchProps> & Subcomponents = ({
  requestOptions,
  contentType,
  sortingList = undefined,
  hitsPerPage,
  withSearchbar = false,
  withFacets = false,
  withPagination = false,
  children,
  ...restProps
}) => (
  <SearchkitWrapper
    {...restProps}
    connection={{
      host: SEARCHKIT_HOST_URL,
    }}
    indexName={APP_OPTIONS?.parameters.searchkitIndexAllContent}
    routing={false}
    analytics
    hitsPerPage={hitsPerPage}
    requestOptions={requestOptions}
    searchSettings={{
      search_attributes: searchAttributes,
      result_attributes: resultAttributes,
      facet_attributes: facetAttributes,
      sorting,
    }}
  >
    {children || (
      <Inner
        contentType={contentType}
        sortingList={sortingList}
        withSearchbar={withSearchbar}
        withFacets={withFacets}
        withPagination={withPagination}
      />
    )}
  </SearchkitWrapper>
);

MetaSearch.EmptyState = EmptyState;
MetaSearch.Facets = Facets;
MetaSearch.Inner = Inner;

export default MetaSearch;
